import { USER_SIGN_IN_SUCCESS, USER_IS_ADMIN} from "Store/constants";
function  AuthDirectiveFn(UIExtension, emitter, {getEmail, hasSignIn, isAdmin}) {
    function addListener(event, handler) {
        emitter.on(event, handler);
        return () => {
          emitter.removeListener(event, handler);
        }
      }
    class AuthDirective extends UIExtension.Directive {
        static getName() {
            return 'auth';
        }
        showComponentAfterSignIn(){
          if(this.attrValue === 'unlogin'){
            this.component.hide();
          } else if(this.attrValue === 'login'){
            this.component.show();
          } else if(this.attrValue === 'isAdmin'){
            isAdmin?this.component.show():this.component.hide();
          } else if(this.attrValue === 'email'){
            this.component.setText(getEmail())
          }
        }
        showComponentBeforeSignIn(){
          if(this.attrValue === 'unlogin'){
            this.component.show();
          }else if(this.attrValue === 'login'){
            this.component.hide();
          } else if(this.attrValue === 'isAdmin'){
            this.component.hide();
          }
        }

        componentMounted() {
            console.info('auth', this);
            if(hasSignIn){
              this.showComponentAfterSignIn();
            }else{
              this.showComponentBeforeSignIn();
            }

            this.addDestroyHook(
              addListener(USER_SIGN_IN_SUCCESS, () => {
                this.showComponentAfterSignIn();
              }),
              addListener(USER_IS_ADMIN, ()=>{
                if(this.attrValue === 'isAdmin'){
                  this.component.show();
                }
              })
            );
        }
    }
    UIExtension.modular.module('phantom').getRegistry().registerDirective(AuthDirective);
}

export default AuthDirectiveFn;